import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "airConditioningFilled"
const AirConditioningFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M15.32 4.375 16.44 2.438 18.062 3.376 16.944 5.312 19.368 4.663 19.853 6.473 15.618 7.609 13.624 11.063H17.612L20.712 7.963 22.038 9.287 20.263 11.062H22.5V12.939H20.263L22.038 14.712 20.712 16.038 17.612 12.938H13.624L15.617 16.39 19.852 17.526 19.367 19.336 16.943 18.688 18.061 20.624 16.438 21.562 15.319 19.625 14.67 22.049 12.86 21.564 13.994 17.328 12 13.875 10.006 17.328 11.141 21.564 9.33 22.049 8.68 19.625 7.562 21.562 5.938 20.624 7.057 18.687 4.633 19.337 4.148 17.527 8.383 16.39 10.376 12.938H6.388L3.288 16.038 1.962 14.712 3.737 12.938H1.5V11.062H3.737L1.962 9.289 3.288 7.962 6.388 11.062H10.376L8.382 7.608 4.147 6.474 4.632 4.664 7.056 5.311 5.938 3.376 7.562 2.438 8.68 4.375 9.33 1.95 11.14 2.436 10.006 6.671 12 10.125 13.994 6.671 12.86 2.436 14.67 1.951z" />
        </svg>
      }
    </span>
  )
}
export default AirConditioningFilledIcon
